export default "__VITE_ASSET__DVC0A_F5__"